export default {
  DRIVETRAIN: "Motricité",

  DRIVETRAIN_AWD: "Transmission intégrale (AWD)",
  DRIVETRAIN_4WD: "Quatre roues motrices (4WD)",
  DRIVETRAIN_FWD: "Traction avant (FWD)",
  DRIVETRAIN_RWD: "Propulsion (RWD)",
};
